import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody41.css';

import clientimg from '../images/case-study-client41.webp'
import outcome from '../images/outcome41.webp'

import sm1 from '../images/cs41so1.webp'
import sm2 from '../images/cs41so2.webp'
import sm3 from '../images/cs41so3.webp'
import sm4 from '../images/cs41so4.webp'


const Casestudybody41 = () => {

    return (
        <>
        <section className='casestudybody41-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A prominent family office focusing on venture, growth and buyout investments across diverse sectors  </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought to translate broad coffee industry focus into actionable investment themes. With limited visibility into sub-sector dynamics and market fragmentation, the client required a structured research to identify high-potential niches and build a qualified acquisition pipeline</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody41-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Workshops: </h4>
                          <p>Facilitated structured workshops with the client to <span style={{color:"#03A393",fontWeight:700}}> align on expectations, understand the firm's historical exposure to the industry, and clarify investment preferences</span> such as target size, business models of interest, and geographic scope</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Industry Assessment:</h4>
                          <p>Conducted a comprehensive <span style={{color:"#03A393",fontWeight:700}}> evaluation of the industry,</span> including segmentation into sub-sectors, estimation of market size, identification of structural trends, consumption patterns, and demand drivers</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Market Landscape Development:</h4>
                          <p>Created a <span style={{color:"#03A393",fontWeight:700}}> visual landscape of the industry and its sub-sectors,</span> mapping value chain participants and identifying zones of fragmentation, whitespace, and recent M&A activity</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Risk Analysis:</h4>
                          <p>Assessed each sub-sector for potential risks such as <span style={{color:"#03A393",fontWeight:700}}> regulatory hurdles, technology disruption, customer concentration and cyclicality,</span> enabling a balanced view of opportunity vs. exposure</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Target Identification: </h4>
                          <p>Built a <span style={{color:"#03A393",fontWeight:700}}> qualified list of acquisition targets</span> within the most promising sub-sectors using a blend of proprietary databases, public filings, digital tools, and sector reports. After initial identification, conducted <span style={{color:"#03A393",fontWeight:700}}> deep-dive analysis on high-priority companies</span> including reviewing operating models, customer base, unit economics, and, analysing individual franchisees to assess network quality and scalability</p>
                        </div>
                      </div>     

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Theme Memo Preparation:</h4>
                          <p>For each shortlisted theme, developed a <span style={{color:"#03A393",fontWeight:700}}> concise investment memo</span> outlining the rationale, supporting data, risk profile, key players, and initial outreach considerations, structured to inform next-step sourcing actions</p>
                        </div>
                      </div>             

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                       </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody41-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a set of investment themes along with a detailed list of potential acquisition targets. The output enabled the client to refine its sourcing strategy and confidently initiate targeted outreach within the identified sub-sectors</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody41
